<div id="card-config" class="card col-xs-12">
    <div class="row" *ngIf="!editGeneral">
    <div class="col-sm-10">
      <div class="row">
        <div class="col-sm-3 ">
          <div (click)="clickImageChange()" class="profile-pic">
            <img [src]="profilePicture" (load)="onImageLoad()" [ngClass]="{'hidden-image': !imageLoaded}" style="width: 100%; height: 100%;">
            <span>Alterar</span>
          </div>
          <input (change)="fileChangeEvent($event)" type="file" id="profile-image" style="display: none;">
          <a (click)="removeImage($event)" href="#" class="remove-pic">Remover</a>
        </div>
        <div class="col-sm-9 info-geral">
          <div class="row">
            <div class="col-sm-6">
              <div class="form-group" animate="fadeIn" delay="300">
                <label for="" class="control-label">Razão Social</label>
                <h5 *ngIf="!editGeneral" class="mar-no">{{conta.RazaoSocial}}</h5>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group" animate="fadeIn" delay="300">
                <label for="" class="control-label">Fantasia</label>
                <h5 *ngIf="!editGeneral" class="mar-no">{{conta.Fantasia}}</h5>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-6">
              <div class="form-group" animate="fadeIn" delay="300">
                <label for="" class="control-label">CPF/CNPJ</label>
                <h5 *ngIf="!editGeneral" class="mar-no">{{conta.CpfCnpj.length === 11 ? mascaraCpf(conta.CpfCnpj) : mascaraCnpj(conta.CpfCnpj)}}</h5>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group" animate="fadeIn" delay="300">
                <label for="" class="control-label">Telefone</label>
                <h5 *ngIf="!editGeneral" class="mar-no">{{mascaraTelefone(conta.Telefone)}}</h5>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <div class="form-group" animate="fadeIn" delay="300">
                <label for="" class="control-label">Endereço</label>
                <h5 *ngIf="!editGeneral" class="mar-no">{{endereco.Logradouro}}<span *ngIf="endereco.Numero">, {{endereco.Numero}}</span><span *ngIf="endereco.Complemento">, {{endereco.Complemento}}</span> - {{endereco.Bairro}}, {{endereco.Cidade}} - {{endereco.Estado}}, {{mascaraCep(endereco.Cep)}}</h5>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-2">
        <button (click)="clickBtnGeral($event)" type="submit" id="submit-geral" class="btn btn-grey pull-right">Editar</button>
    </div>
  </div>

  <form *ngIf="editGeneral" class="row">
    <div class="col-md-10">
        <div class="row text-left">
          <div class="col-sm-4">
            <div class="form-group" animate="fadeIn" delay="300">
              <label for="" class="control-label">Razão Social</label>
              <input class="form-control" type="text" [(ngModel)]="conta.RazaoSocial" name="RazaoSocial">
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group" animate="fadeIn" delay="300">
              <label for="" class="control-label">Fantasia</label>
              <input class="form-control" type="text" [(ngModel)]="conta.Fantasia" name="Fantasia">
            </div>
          </div>
        </div>

        <div class="row text-left">
          <div class="col-sm-3">
            <div class="form-group" animate="fadeIn" delay="300">
              <label for="" class="control-label">CNPJ</label>
              <input class="form-control" type="text" mask="00.000.000/0000-00" [(ngModel)]="conta.CpfCnpj" name="CpfCnpj">
            </div>
          </div>
          <div class="col-sm-3">
            <div class="form-group" animate="fadeIn" delay="300">
              <label for="" class="control-label">Telefone</label>
              <input class="form-control" type="text" maxlength="15" (input)="telefoneValue($event)" [(ngModel)]="conta.Telefone" name="Telefone">
            </div>
          </div>
        </div>

        <div class="row text-left">
          <div class="col-sm-3">
            <div class="form-group" animate="fadeIn" delay="300">
              <label for="" class="control-label">Cep</label>
              <input class="form-control" type="text" mask="00000-000" [(ngModel)]="endereco.Cep" name="Cep">
            </div>
          </div>
        </div>

        <div class="row text-left">
          <div class="col-sm-5">
            <div class="form-group" animate="fadeIn" delay="300">
              <label for="" class="control-label">Logradouro</label>
              <input class="form-control" type="text" [(ngModel)]="endereco.Logradouro" name="Logradouro">
            </div>
          </div>
          <div class="col-sm-5">
            <div class="form-group" animate="fadeIn" delay="300">
              <label for="" class="control-label">Complemento</label>
              <input class="form-control" type="text" [(ngModel)]="endereco.Complemento" name="Complemento">
            </div>
          </div>
          <div class="col-sm-2">
            <div class="form-group" animate="fadeIn" delay="300">
              <label for="" class="control-label">Número</label>
              <input class="form-control" type="text" [(ngModel)]="endereco.Numero" name="Numero">
            </div>
          </div>
        </div>

        <div class="row text-left">
          <div class="col-sm-4">
            <div class="form-group" animate="fadeIn" delay="300">
              <label for="" class="control-label">Bairro</label>
              <input class="form-control" type="text" [(ngModel)]="endereco.Bairro" name="Bairro">
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group" animate="fadeIn" delay="300">
              <label for="" class="control-label">Cidade</label>
              <input class="form-control" type="text" [(ngModel)]="endereco.Cidade" name="Cidade">
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group" animate="fadeIn" delay="300">
              <label for="" class="control-label">Estado</label>
              <input class="form-control" type="text" [(ngModel)]="endereco.Estado" name="Estado">
            </div>
          </div>
        </div>
    </div>
    <div class="col-md-2">
      <button (click)="clickBtnGeral($event)" type="submit" id="submit-geral" class="btn btn-blue pull-right">Salvar</button>
    </div>
  </form>
  <button (click)="openTokenModal()" class="btn btn-grey pull-right token-button">Token de Atendimento</button>
</div>

<!-- Modal -->
<div id="modal-upload" class="modal fade" role="dialog">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" data-dismiss="modal">&times;</button>
        <h4 class="modal-title">Selecione uma área da imagem</h4>
      </div>
      <div class="modal-body">
        <img id="image" src="">
        <div class="send-image">
          <button class="btn btn-registrar" *ngIf="!sendingImage" (click)="sendImage()">Enviar</button>
          <button class="btn btn-registrar loading" *ngIf="sendingImage">Enviar</button>
        </div>  
      </div>
    </div>
  </div>
</div>
<!-- Fim Modal -->


<div id="modal-token" class="modal fade" role="dialog">
  <div class="modal-dialog token-modal">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" data-dismiss="modal">&times;</button>
        <h4 class="modal-title">Token de Atendimento</h4>
      </div>
      <div class="modal-body token-modal-body">
        <ng-container *ngIf="loadingToken || errorToken">
          <div *ngIf="loadingToken && !errorToken" class="container-loading">
            <div class="btn btn-registrar loading"></div>
          </div>
          <p class="erro" *ngIf="!loadingToken && errorToken">Erro ao gerar Token de Atendimento.</p>
        </ng-container>

  
        <ng-container *ngIf="!loadingToken && !errorToken">
          <p class="token-modal-description">Informe esse código ao nosso Atendimento para podermos acessar o seu Pague.lá! Mas não se preocupe, este acesso não nos permite fazer alterações em seus dados.</p>
        
          <div class="input_group">
            <input class="form-control token-input" mask="000-000-000" id="urlLoginTemporario" name="urlLoginTemporario" [ngModel]="codigoLogin" readonly type="text">
            <div class="input-group-append">
              <button class="btn btn-default btn-copiar" (click)="copyToClipboard()" tooltip data-toggle="tooltip" title="Copiar" data-animation="false" data-placement="bottom"><i class="fa fa-copy"></i></button>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>

  <ng-container *ngIf="showToast">
    <div class="toast">Copiado</div>
  </ng-container>
</div>


